import axios from 'axios';
import { PondsWithFeeders } from 'views/production-systems/features/farm-setup/types/feeders.type';

// POST Pond Status (Feeder)
// ewosapi/v1/shrimps/feeder/pond-status?globalSiteId={globalSiteId}&statusDate={statusDate}
export const postPondStatusFeeders = async (globalSiteId: string, statusDate: string, pondIds: string[]) => {
  const res = await axios.post<PondsWithFeeders>(
    `/ewosapi/v1/shrimps/feeder/pond-status?globalSiteId=${globalSiteId}&statusDate=${statusDate}`,
    {
      pondIds: pondIds,
    }
  );
  return res.data;
};
